import request from '@/utils/request'


// 查询用户积分变动记录列表
export function listScoreRecord(query) {
  return request({
    url: '/user/score/record/list',
    method: 'get',
    params: query
  })
}

// 查询用户积分变动记录分页
export function pageScoreRecord(query) {
  return request({
    url: '/user/score/record/page',
    method: 'get',
    params: query
  })
}

// 查询用户积分变动记录详细
export function getScoreRecord(data) {
  return request({
    url: '/user/score/record/detail',
    method: 'get',
    params: data
  })
}
export function getBalanceRecord(data) {
  return request({
    url: '/user/balanceRecord/page',
    method: 'get',
    params: data
  })
}


// 新增用户积分变动记录
export function addScoreRecord(data) {
  return request({
    url: '/user/score/record/add',
    method: 'post',
    data: data
  })
}

// 修改用户积分变动记录
export function updateScoreRecord(data) {
  return request({
    url: '/user/score/record/edit',
    method: 'post',
    data: data
  })
}

// 删除用户积分变动记录
export function delScoreRecord(data) {
  return request({
    url: '/user/score/record/delete',
    method: 'post',
    data: data
  })
}
